import { Divider, Text } from '$components'
import { LogoIcon } from '$components'

export function InvitationFooter() {

  return (
    <div className="mt-stack-hero w-full">
      <Divider />

      <div className="mt-stack-grid flex flex-col">
        <LogoIcon className="w-24 h-fit mb-stack-roomy" />

        <Text
          type="s"
          className="text-fg-subtle font-light"
        >
          Less admin, more grooming.
        </Text>
      </div>
    </div>
  )
}
